<template>
  <div id="relatedLoans" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Related Request Code</v-toolbar-title>
      <v-btn icon small @click="refreshData" color="#3F4360">
        <img
            :src="computeRefreshLogo"
            alt="Refresh"
            class="height-24"
        />
      </v-btn>
    </v-toolbar>
    <v-container>
      <div class="flex-title-request">
<!--        <v-spacer></v-spacer>-->
        <div>
          Request Code : {{ requestCode }}
        </div>
        <div>
          <v-btn
              color="#5C82E3"
              class="m-r-0 m-l-20"
              style="padding: 8px;"
              text
              @click="sortByCreateTime"
          >
            Create Time
          </v-btn>
          <v-btn
              color="#5C82E3"
              class="p-r-0"
              style="margin-right: 24px;"
              icon
          >
            <v-icon
                @click="sortByCreateTime">{{ this.sortTime ? 'mdi-arrow-down' : 'mdi-arrow-up' }}</v-icon>
          </v-btn>
        </div>
      </div>
      <related-request-code-queue :relatedRequestCode="relatedRequestCode" :loan="loan" :tabLoading="tabLoading" :loanData="loanData"></related-request-code-queue>
    </v-container>
  </div>
</template>
<script>
import { Tool, DataType } from '@/util/index'
import RelatedRequestCodeQueue from '@/components/panda/common/queue/RelatedRequestCodeQueue'
import { OriginationBusinessApi } from '@/api/lms/origination-business'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'
import { OriginationApi } from '@/api/pandaria'

const tool = new Tool()
export default {
  name: 'related-request-code',
  components: { RelatedRequestCodeQueue },
  props: {
    loan: Object
  },
  data () {
    return {
      sortTime: false,
      relatedRequestCode: [],
      sortLoanStatus: '',
      tabLoading: true,
      requestCode: '',
      loanData: {}
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  watch: {},
  mounted () {
    const $this = this
    this.$eventBus.$on('initRelatedRequestCode', target => {
      const request = {
        loanId: this.loanId,
        feature: 'PERSONAL,BANK,IBV'
      }
      OriginationApi.getLoanByIdAndFeature(request, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.loanData = result
          if (tool.isNotEmpty(result.ibvDataList)) {
            result.ibvDataList.map(item => {
              if (tool.isNotEmpty(item.providerStatus)) {
                if (item.providerStatus === 1) {
                  $this.requestCode = item.requestCode
                } else if (parseInt(item.provider) === DataType.IBVProviderType.DECISION_LOGIC.value) {
                  $this.requestCode = item.requestCode
                }
              } else if (parseInt(item.provider) === DataType.IBVProviderType.DECISION_LOGIC.value) {
                $this.requestCode = item.requestCode
              } else if (tool.isEmpty($this.requestCode) && parseInt(item.provider) === DataType.IBVProviderType.CHIRP.value) {
                $this.requestCode = item.requestCode
              }
            })
          }
        }
      })
    })
  },
  methods: {
    sortByCreateTime () {
      const $this = this
      if (tool.isNotEmpty($this.relatedRequestCode)) {
        $this.relatedRequestCode.sort(function (a, b) {
          if ($this.sortTime) {
            return a.createdAt - b.createdAt
          } else {
            return b.createdAt - a.createdAt
          }
        })
      }
      $this.sortTime = !($this.sortTime)
      this.$forceUpdate()
    },
    getRelatedRequestCode () {
      const $this = this
      OriginationBusinessApi.getRelatedRequestCode({ loanId: this.loanId }, function (result) {
        $this.tabLoading = false
        if (tool.isNotEmpty(result)) {
          $this.relatedRequestCode = result
        }
      }, function () {
        $this.tabLoading = false
      })
    },
    refreshData () {
      this.getRelatedRequestCode()
    }
  }
}
</script>
<style scoped>
.flex-title-request {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 14px;
}
</style>
